<template>
  <div
    class="o-card"
    :class="{'o-card--no-padding': noPadding }"
  >
    <div
      v-if="loading"
      class="
        tw-absolute tw-inset-0 tw-z-50
        tw-bg-white tw-bg-opacity-75
        tw-flex tw-justify-center tw-items-center
      "
    >
      <bounce-loader
        :color="(($theme || {}).colors || {}).orange || '#FF5B35'"
        :size="60"
      />
    </div>
    <slot name="header" />
    <slot />
    <slot name="footer" />
  </div>
</template>

<script>
  import { BounceLoader } from '@saeris/vue-spinners';

  export default {
    components: {
      BounceLoader,
    },
    props: {
      noPadding: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style lang="scss" scoped>
.o-card {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: 1px solid $lighterGrey;
  background-color: #ffffff;
  color: $black;
  transition: 0.3s;
  padding: 20px;
  position: relative;
  &.o-card--no-padding {
    padding: 0;
  }
}
</style>
